/* XTS Internal: This file is autogenerated by the build system. To update use codegen */
import type * as Types from '../../../../src/interfaces/xingOne';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type XssGetFeatureSwitchesQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type XssGetFeatureSwitchesQuery = {
  viewer?: Types.Maybe<Pick<Types.Viewer, 'featureSwitches'>>;
};

export const XssGetFeatureSwitchesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'xssGetFeatureSwitches' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'featureSwitches' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useXssGetFeatureSwitchesQuery__
 *
 * To run a query within a React component, call `useXssGetFeatureSwitchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useXssGetFeatureSwitchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useXssGetFeatureSwitchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useXssGetFeatureSwitchesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    XssGetFeatureSwitchesQuery,
    XssGetFeatureSwitchesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    XssGetFeatureSwitchesQuery,
    XssGetFeatureSwitchesQueryVariables
  >(XssGetFeatureSwitchesDocument, options);
}
export function useXssGetFeatureSwitchesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    XssGetFeatureSwitchesQuery,
    XssGetFeatureSwitchesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    XssGetFeatureSwitchesQuery,
    XssGetFeatureSwitchesQueryVariables
  >(XssGetFeatureSwitchesDocument, options);
}
export type XssGetFeatureSwitchesQueryHookResult = ReturnType<
  typeof useXssGetFeatureSwitchesQuery
>;
export type XssGetFeatureSwitchesLazyQueryHookResult = ReturnType<
  typeof useXssGetFeatureSwitchesLazyQuery
>;
export type XssGetFeatureSwitchesQueryResult = Apollo.QueryResult<
  XssGetFeatureSwitchesQuery,
  XssGetFeatureSwitchesQueryVariables
>;
